import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class CheckEmailValidity extends ApplicationRecord {
  static jsonapiType = "check_email_validity";

  @Attr() email: string;

  @Attr() emailValid: string;

  @Attr() resourceType: string;
}

export default CheckEmailValidity;
